import React, { useState } from 'react'
import { CollectionItem } from 'mytours-read-common'
import { IonRow, IonText, IonCol, IonButton, IonGrid } from '@ionic/react'

import { getImageAlt } from '../../functions'
import { ImageSizePreset } from '../../../../common_lib/types'
import { generateImageSrcSet, generateImageUrl } from '../../../../common_lib/utils'
import { isRTL } from 'mobile_web/modules/platform'
import classNames from 'classnames'

import './styles/menuListItem.less'

interface Props {
	isActive: boolean
	item: CollectionItem
	onSelect: () => void
}

const MenuListItem: React.FC<Props> = props => {
	const [failedToLoadImage, setFailedToLoadImage] = useState<boolean>(false)

	const clearFailedToLoadImageFlag = () => {
		if (failedToLoadImage) {
			setFailedToLoadImage(false)
		}
	}

	const setFailedToLoadImageFlag = () => {
		if (!failedToLoadImage) {
			// set failed to load to true so we should background of image so user can see there is actually an item (if item has no title too)
			setFailedToLoadImage(true)
		}
	}

	if (!props.item) {
		return null
	}

	const imageObject = props.item.cover_image_grid || props.item.cover_image
	const imageFocalPoint = imageObject?.file?.focal_point
	const imageCrop = imageFocalPoint && (imageFocalPoint[0] !== 0.5 || imageFocalPoint[1] !== 0.5)
	const imageUrl =
		imageObject?.file &&
		generateImageUrl(imageObject?.file, {
			imageSizePreset: ImageSizePreset.Thumbnail,
			crop: imageCrop,
			focalPoint: imageFocalPoint,
		})
	const imageSrcSet =
		imageObject?.file &&
		generateImageSrcSet(imageObject?.file, {
			imageSizePreset: ImageSizePreset.Thumbnail,
			crop: imageCrop,
			focalPoint: imageFocalPoint,
		})


	return (
		<IonRow
			role="button"
			key={props.item.item_id}
			aria-label={props.item.title || ''}
			onClick={props.onSelect}
			className={classNames('menu-list-item', {
				active: props.isActive,
				rtl: isRTL(),
			})}
		>
			<IonCol>
				<IonButton onClick={props.onSelect} expand="full" fill="clear">
					<IonGrid>
						<IonRow>
							{imageUrl && !failedToLoadImage ? (
								<IonCol className="image-col">
									<img
										className="image"
										onLoad={clearFailedToLoadImageFlag}
										onError={setFailedToLoadImageFlag}
										src={imageUrl}
										srcSet={imageSrcSet}
										alt={getImageAlt(imageObject)}
									/>
								</IonCol>
							) : (
								<IonCol className="empty-image" />
							)}
							<IonCol className="titles-container">
								<IonText className="text">{props.item.title}</IonText>
							</IonCol>
						</IonRow>
					</IonGrid>
				</IonButton>
			</IonCol>
		</IonRow>
	)
}

export default MenuListItem
